import moment from 'moment';
import $ from 'jquery'

import {
	ACT_LOGIN, ACT_LOGOUT, ACT_HELP,
	ACT_LOGGING, ACT_REPORT_HOLIDAYS, ACT_REPORT_DISTANCE, ACT_REPORT_LOGGING, ACT_REPORT_TIMESHEET,ACT_REPORT_SUMMARY,ACT_REPORT_ADV,
	ACT_GOTLOGS, ACT_EDITLOG, ACT_NEWLOG, ACT_CANCELADDLOGS, ACT_COPYLOG,
	ACT_GOTPROJECTS, ACT_GOTHOLIDAYPROJECTS, ACT_GOTILLNESSPROJECTS, ACT_GOTJOBDAYINFO, ACT_GOTRECENTPROJECTS
} from './actions.js';

import { ACT_FN_DISPATCH, ACT_FN_SETLOGTOEDIT, ACT_SELECTPERIOD } from './actions.js';



export const app = (state = { dispatch: undefined, edit: false, logsReceived: false }, action) =>  {
	switch (action.type) {
		case ACT_FN_DISPATCH:
			//console.log("dispatch function set")
			return $.extend( {}, state, { dispatch: action.fn } );
			
		case ACT_EDITLOG:
		case ACT_NEWLOG:
			return $.extend( {}, state, { edit: true } );
		//case ACT_ADDLOG:
		//case ACT_UPDATELOG:
		case ACT_GOTLOGS:
			return $.extend({}, state, { edit: false, logsReceived: true });
		case ACT_CANCELADDLOGS:
		case ACT_REPORT_HOLIDAYS:
		case ACT_REPORT_DISTANCE:
		case ACT_REPORT_LOGGING:
		case ACT_REPORT_TIMESHEET:
		case ACT_REPORT_ADV:
			return $.extend( {}, state, { edit: false } );
		case ACT_LOGOUT:
			return $.extend({}, state, { logsReceived: false, edit: false });	
		
		default:
			return state
	}
}

export const period = (state = { startDate: moment().startOf('day')/*, startLogs: moment().startOf('day'), endLogs: moment().startOf('day')*/ }, action) => {
	switch (action.type) {
		case ACT_SELECTPERIOD:
			return $.extend( {}, state, { startDate: action.startDate, endDate:action.endDate } );
		case ACT_GOTLOGS:
			//console.log("setting startlog to:" + JSON.stringify(moment(action.logs.start).format("DD/MM/YYYY hh:mm:ss")))
			return $.extend({}, state, { startLogs: moment(action.logs.start), endLogs: moment(action.logs.end) });
		default:
			return state
	}
}

export const user = (state = { user: '', userInfo: { userFullName: '', token: '', code: '' }, loggedIn: false}, action) =>  {
	switch (action.type) {
		case ACT_LOGIN:
			//console.log("trylogin")
			//console.log("NEW TOKEN SET:" + action.userInfo.token)
			return $.extend( {}, state, { user: action.user, userInfo:action.userInfo, loggedIn:true } );
			
		case ACT_LOGOUT:
			//console.log("Logout")
			return $.extend({}, state, { /*user: '',*/ userInfo: { userFullName: '', token: '', code: '' }, loggedIn: false});

		case ACT_GOTJOBDAYINFO:
			return $.extend({}, state, { jobDayInfo: action.jobDayInfo });

		default:
			return state
	}
}

export const menu = (state = {menu: 'logging'}, action) => {
	switch (action.type) {
		case ACT_LOGOUT:
			//console.log("Logout")
			return $.extend( {}, state, {menu: '' });
		case ACT_LOGIN:
		case ACT_LOGGING:
			//console.log("Logout")
			return $.extend( {}, state, {menu: 'logging' });
		case ACT_HELP:	
			return $.extend( {}, state, {menu: 'help'} );
		case ACT_REPORT_HOLIDAYS:
			//console.log("HolidayReport")
			return $.extend( {}, state, {menu: 'holidayreport'} );
		case ACT_REPORT_DISTANCE:
			//console.log("DistanceReport")
			return $.extend( {}, state, {menu: 'distancereport'} );
		case ACT_REPORT_LOGGING:
			//console.log("logReport")
			return $.extend( {}, state, {menu: 'logreport'} );
		case ACT_REPORT_TIMESHEET:
			//console.log("logReport")
			return $.extend({}, state, { menu: 'timesheetreport' });
		case ACT_REPORT_SUMMARY:
			//console.log("summaryReport")
			return $.extend({}, state, { menu: 'summaryreport' });
		case ACT_REPORT_ADV:
			//console.log("logReport")
			return $.extend( {}, state, {menu: 'advreport'} );
		default:
			return state
	}
}

export const logging = (state = { lstLoggings: [], lastLog: { projectId: -1, projectItemId: -1, duration: 1 }}, action) =>  {
	var lst
	var idx
	switch (action.type) {
		case ACT_LOGOUT:
			return $.extend({}, state, { lstLoggings: [] });
		case ACT_GOTLOGS:
			//console.log("Received "+action.logs.length+" loggings")
			lst = []
			action.logs.logs.forEach(function (log) {
				let prjName = log.project_nameField.toLowerCase()
				lst.push({
					projectId : log.project_idField, 
					projectItemId : log.project_item_idField,
					duration : log.durationField,
					location : log.locationField,
					distance : log.distanceField,
					comments : log.descriptionField,
					startDate: log.dateField,
					projectName: log.project_nameField,
					projectItemName: log.project_item_nameField,
					logId: log.logging_idField,
					isHoliday: prjName.indexOf('verlof') >= 0,
					isIllness: prjName.indexOf('ziek') >= 0,
					homework: log.home_workField,
					compensation: log.day_compensationField,
					compensationAbroad: log.abroad_compensationField
						})
				
			})
			return $.extend({}, state,
				{ lstLoggings: lst },
				{ workRegimes: [ ...action.logs.workRegimes ] },
				{ lastLog: action.log },
				{ selectedProjectId: (action.log === undefined ? -1 : action.log.projectId) },
				{ selectedProjectItemId: (action.log === undefined ? -1 : action.log.projectItemId) });
		case ACT_EDITLOG:
			idx = state.lstLoggings.findIndex((log)=>{	return (log.logId === action.logId)	})
			state.editLog(state.lstLoggings[idx])
			return state

		case ACT_COPYLOG:
			idx = state.lstLoggings.findIndex((log) => { return (log.logId === action.logId) })
			return $.extend({}, state, { logToCopy: state.lstLoggings[idx]});
			
		case ACT_FN_SETLOGTOEDIT:
			//console.log("seteditlog function set")
			return $.extend( {}, state, { editLog: action.fn } );
			
		default:
			return state
	}
}

export const projects = (state = { allProjects: [], recentProjects:[] }, action) => {
	switch (action.type) {
		case ACT_GOTPROJECTS:
			return $.extend({}, state, { allProjects: action.projects });
		case ACT_GOTHOLIDAYPROJECTS:
			//console.log("got holiday projects:" + action.holidayPrjs)
			return $.extend({}, state, { holidayPrjs: action.holidayPrjs });
		case ACT_GOTILLNESSPROJECTS:
			//console.log("got illness projects:" + action.illnessPrjs)
			return $.extend({}, state, { illnessPrjs: action.illnessPrjs });
		case ACT_GOTRECENTPROJECTS:
			//console.log("got new recent projects:" + JSON.stringify(action.recentProjects))
			return $.extend({}, state, { recentProjects: action.recentProjects });
		default:
			return state
	}
}
